import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "address", "city", "postalCode", "country", "state", "input", "streetNumber" ]

  connect() {
    this.geocoder = new MapboxGeocoder({
      accessToken: this.authToken,
      types: 'address,place', // Support both full addresses and cities
      mapboxgl: false
    })

    this.geocoder.on('result', (event) => {
      this.updateAddressFields(event)
    })

    const geocoderElement = this.geocoder.onAdd()
    this.inputTarget.appendChild(geocoderElement)

    geocoderElement.classList.add('!w-full', '!max-w-none')
  }

  updateAddressFields(event) {
    const isPlace = event.result.place_type && event.result.place_type.includes('place')

    const postalCodeContext = event.result.context?.find(c => c.id.startsWith('postcode'))
    if (postalCodeContext && this.hasPostalCodeTarget) {
      this.postalCodeTarget.value = postalCodeContext.text
    }

    // For places (cities), use the main text as city, for addresses find city in context
    if (isPlace && this.hasCityTarget) {
      this.cityTarget.value = event.result.text
    } else {
      const cityContext = event.result.context?.find(c => c.id.startsWith('place'))
      if (cityContext && this.hasCityTarget) {
        this.cityTarget.value = cityContext.text
      }
    }

    const countryContext = event.result.context?.find(c => c.id.startsWith('country'))
    if (countryContext && this.hasCountryTarget) {
      this.countryTarget.value = countryContext.short_code.toUpperCase()
    }

    const regionContext = event.result.context?.find(c => c.id.startsWith('region'))
    if (regionContext && this.hasStateTarget) {
      this.stateTarget.value = regionContext.text
    }

    // Only fill address for actual addresses, not for places (cities)
    if (this.hasAddressTarget) {
      if (isPlace) {
        // Clear address field for city-only selection
        this.addressTarget.value = ''
      } else {
        // For full addresses, combine street number and street name
        const streetNumber = event.result.address
        const streetName = event.result.text

        if (streetNumber !== undefined) {
          if (this.hasStreetNumberTarget) {
            // If there's a separate street number field, use it
            this.streetNumberTarget.value = streetNumber
            this.addressTarget.value = streetName
          } else {
            // Otherwise, combine number and street in the address field
            this.addressTarget.value = `${streetNumber} ${streetName}`
          }
        } else {
          this.addressTarget.value = streetName
        }
      }
    }
  }

  get authToken() {
    return document.head.querySelector('meta[name="mapbox_token"]').content;
  }
}
